"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.15,
    once: true
  });
  const faqs = [{
    question: "What is JEEN and what does it do?",
    answer: "Jestu Education Empowerment Network (JEEN) is a nonprofit organization in Uganda dedicated to expanding educational opportunities for underprivileged students through financial assistance, learning materials, and structured mentorship programs."
  }, {
    question: "Who is eligible for JEEN scholarships?",
    answer: "JEEN scholarships are available to students from low-income families in Uganda who demonstrate academic potential and commitment to their education. Applicants must be enrolled or seeking enrollment in a recognized educational institution."
  }, {
    question: "How can I apply for a JEEN scholarship?",
    answer: "To apply, visit our Scholarships page and complete the online application form. You will need to provide academic records, a personal statement, and references from teachers or community leaders."
  }, {
    question: "Does JEEN provide mentorship along with financial support?",
    answer: "Yes, JEEN offers structured mentorship programs designed to build confidence, leadership skills, and career aspirations. Mentors work closely with students throughout their educational journey."
  }, {
    question: "How is JEEN funded?",
    answer: "JEEN is funded through donations from individuals, partner organizations, and community fundraising events. We operate with transparent governance to ensure funds directly support our students and programs."
  }, {
    question: "Can I volunteer or partner with JEEN?",
    answer: "Absolutely! JEEN welcomes volunteers and partners who share our mission. Contact us at info@jeen.org.ug to learn about opportunities to contribute your time, expertise, or resources."
  }];
  return <section className="relative bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-3xl">
        <div ref={ref} className={`transition-all duration-[150ms] ease-[cubic-bezier(0.4,0,0.2,1)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-[10px]"}`}>
          <h2 className="font-display text-3xl sm:text-4xl font-bold text-foreground text-center mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-muted-foreground text-center mb-12 text-base sm:text-lg">
            Find answers to common questions about JEEN's programs, eligibility,
            and how we support students across Uganda.
          </p>

          <Accordion type="single" collapsible className="w-full space-y-3">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border border-border rounded-lg px-6 bg-background shadow-soft hover:shadow-medium transition-shadow duration-[150ms]">
                <AccordionTrigger className="text-foreground font-semibold text-base sm:text-lg py-5 hover:no-underline">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground text-sm sm:text-base leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}